
import { NgIf, NgClass, NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { UserService } from '../../../../services/user.service';
import { CheckboxModule } from 'primeng/checkbox';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-inspector-maintainance',
    imports: [NextPage, TableModule, NgIf, NgFor, CheckboxModule, DropdownModule, NgClass, ButtonModule, FormsModule, TabViewModule],
    templateUrl: './inspector-maintainance.component.html',
    styleUrl: './inspector-maintainance.component.scss'
})
export class InspectorMaintainanceComponent {
  inspectorResult: any = {}
  inspectorWholeData: any[] = [];
  filterUserIdinspectorData: any[] = [];
  filterPlantinspectorData: any[] = [];
  inspectorOptionsUser: any = [];
  inspectorOptionsPlant: any = [];
  selectedInspectorUser: any = '';
  selectedInspectorName: any = '';
  selectedInspectorEmail: any = '';
  selectedInspectorPlant: any = '';
  isLoading: boolean = false;
  isValid: boolean = false;
  showSuccess: boolean = false;
  requiredFlag: boolean = false;
  selectValidMaximo: boolean = false;
  validUserEntered: boolean = false;
  ShowAdded: boolean = false;
  maximoList: any = [];
  selectMaximos: any[] = [];
  facilityName = '';
  userIdEntered = '';
  useremail = '';
  userName = '';
  constructor(private adminService: AdminService, private commonService: CommonService, private userService: UserService,private messageService:NotificationService) {
  }
  ngOnInit() {
    this.isLoading = true;
    this.ShowAdded = false;
    this.facilityName = this.commonService.getCurrentFacilityId();
    this.getInspectorData();
  }
  getInspectorData() {
    this.adminService.getOmcData("IN").subscribe((response: any) => {
      this.inspectorResult = response;
      this.processData()
    });
  }
  processData() {
    this.inspectorOptionsPlant = [...new Set(this.inspectorResult.objPlantMaximoNameList)];
    this.inspectorOptionsPlant = this.inspectorOptionsPlant.map((item: any) => {
      return {
        label: item,
        value: item
      };
    });
    this.inspectorOptionsUser = this.inspectorResult.caiList;
    this.inspectorOptionsUser = this.inspectorOptionsUser.map((item: any) => {
      return {
        label: item,
        value: item,
        email: item,
        displayName: item
      };
    });
    this.inspectorWholeData = this.inspectorResult.omcRecordList;
    this.selectedInspectorUser = this.inspectorOptionsUser[0].value;
    this.inspectorWholeData.map((item: any) => {
      if(item.cai == this.selectedInspectorUser) {
        this.selectedInspectorName = item.displayName;
      }
    });
    this.selectedInspectorPlant = this.inspectorOptionsPlant[0].value;
    this.filterInspectorData();
  }
  filterInspectorData() {
    this.filterUserIdinspectorData = this.inspectorWholeData.filter((item: any) => item.cai === this.selectedInspectorUser);
    this.filterPlantinspectorData = this.inspectorWholeData.filter((item: any) => ('('+item.plantMaximo + ') ' + item.plantName) === this.selectedInspectorPlant);
    this.isLoading = false
  }
  filterChangePlant(event: any) {
    this.filterPlantinspectorData = this.inspectorWholeData.filter((item: any) => ('('+item.plantMaximo + ') ' + item.plantName) === this.selectedInspectorPlant);
  }
  filterChangeUser(event: any) {
    this.filterUserIdinspectorData = this.inspectorWholeData.filter((item: any) => item.cai === this.selectedInspectorUser);
    this.inspectorWholeData.map((item: any) => {
      if(item.cai == this.selectedInspectorUser) {
        this.selectedInspectorName = item.displayName;
      }
    });
  }
  DeleteInspector(record: any) {
    this.showSuccess = false;
    if (confirm(`Are you sure you want to delete a record?`)) {
      this.adminService.deleteOmcData(record.recordID).subscribe((response: any) => {
        this.inspectorWholeData = this.inspectorWholeData.filter((item: any) => item.recordID != record.recordID);
        this.filterUserIdinspectorData = this.filterUserIdinspectorData.filter((item: any) => item.recordID != record.recordID);
        this.filterPlantinspectorData = this.filterPlantinspectorData.filter((item: any) => item.recordID != record.recordID);
        this.messageService.showSuccess('Inspector record deleted successfully' );
        this.showSuccess = true;
      });
    }
  }
  verifyUserId() {
    this.requiredFlag = false;
    this.validUserEntered = false;
    this.showSuccess = false;
    this.ShowAdded = false;
    if (this.userIdEntered.length > 0) {
      this.maximoList = [];
      this.userService.getMaximoByUser(this.userIdEntered,'IN').subscribe({
        next: (response: any) => {
          this.useremail = response.email;
          this.userName = response.displayName;
          this.isValid = response.isValid;
          this.maximoList = response.availablePlants;
        },
        error: (error) => {
          this.validUserEntered = true;
          this.messageService.showError('Please enter a valid User ID');
          this.useremail = '';
          this.userName = '';
          this.selectMaximos = [];
          this.maximoList = [];
          this.isValid = false;
        }
      });
    }
    else {
      this.messageService.showError('Please enter a valid User ID' );
      this.requiredFlag = true;
    }
  }
  addNewINS() {
    this.selectValidMaximo = false;
    if (this.selectMaximos.length == 0) {
      this.messageService.showError('Please select at least one plant');
      this.selectValidMaximo = true;
      return;
    }
    let payload = {
      "cai": this.userIdEntered,
      "email": this.useremail,
      "displayName": this.userName,
      "plantsListToBeAdded": this.selectMaximos,
      "facilityId": this.facilityName,
      "type": "IN"
    }
    this.userService.addMaximoForUser(payload).subscribe({
      next: (response: any) => {
        this.messageService.showSuccess('Inspector record added successfully');
        // this.getInspectorData();
        this.userIdEntered = '';
        this.useremail = '';
        this.userName = '';
        this.selectMaximos = [];
        this.ShowAdded = true;
        this.maximoList = [];
        this.isValid = false;
        this.getInspectorData();
      },
      error: (error) => {
        console.error(error);
        this.messageService.showError('Error adding Inspector record' );
      }
    });
  }
  tabClick(){
    this.showSuccess = false;
    this.ShowAdded = false;
  }
}
